import { Dispatch, SetStateAction, createContext, use } from 'react'

type MessageContextVaue = {
  isLoading: string[]
  setIsLoading: Dispatch<SetStateAction<string[]>>
}

export const MessageContext = createContext<MessageContextVaue | null>(null)

export function useMessageContext() {
  const context = use(MessageContext)
  if (!context) {
    throw new Error('useMessageContext must be used within a Message')
  }
  return context
}
